<accordion>
  <accordion-group heading="Dynamic Body Content">
    <p>The body of the accordion group grows to fit the contents</p>
    <button type="button" class="btn btn-primary btn-sm" (click)="addItem()">Add
      Item
    </button>
    <div *ngFor="let item of items">{{item}}</div>
  </accordion-group>
  <accordion-group heading="Content 2">
    <p>accordion 2</p>
  </accordion-group>
  <accordion-group heading="Content 3">
    <p>accordion 3</p>
  </accordion-group>
</accordion>
